import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { ApiService } from './api.service';
import { inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReplacerService {

  patterns = ['@boo'];
  purchase: any;


  apiService: ApiService = inject(ApiService);
  constructor() { }

  async replace(text: string, booking: any) {
    const tokens = text.split(/\s+/ig);
    for (const t of tokens) {
      let pattern = t.match(/\@.+/ig);
      if (pattern) {
        let p = pattern[0].trim();
        switch(p) {
          case '@date':
            try {
              text = text.replace('@date', moment().utc().tz('Europe/London').format('DD/MM/YYYY'));
            }
            catch (err) {
              console.error(err);
            }
            break;
          case '@bookingdate':
            try {
              text = text.replace('@bookingdate', moment(booking.datetime).utc().tz('Europe/London').format('DD/MM/YYYY'));
            }
            catch (err) {
              console.error(err);
            }
            break;
          case '@bookingtime':
            try {
              text = text.replace('@bookingtime', moment(booking.datetime).utc().tz('Europe/London').format('HH:mm:ss'));
            }
            catch (err) {
              console.error(err);
            }
            break;
          case '@price':
            try {
              console.log('THIS PURCHASE', this.purchase);
              if (!this.purchase) {
                this.purchase = await this.apiService.getPurchase(booking.company_id, booking.service_id, booking.purchase_id);
              }
              let GBP = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
              });
              text = text.replace('@price', GBP.format(this.purchase.price/100));
            }
            catch (err) {
              console.error(err);
            }
            break;
          case '@paid':
            try {
              console.log('THIS PURCHASE', this.purchase);
              if (!this.purchase) {
                this.purchase = await this.apiService.getPurchase(booking.company_id, booking.service_id, booking.purchase_id);
              }
              let GBP = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
              });
              text = text.replace('@paid', GBP.format(this.purchase.paid/100));
            }
            catch (err) {
              console.error(err);
            }
            break;
          case '@remaining':
            try {
              console.log('THIS PURCHASE', this.purchase);
              if (!this.purchase) {
                this.purchase = await this.apiService.getPurchase(booking.company_id, booking.service_id, booking.purchase_id);
              }
              let GBP = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
              });
              text = text.replace('@remaining', GBP.format((this.purchase.price - this.purchase.paid)/ 100));
            }
            catch (err) {
              console.error(err);
            }
            break;
        }
      }
    }
    return text;
  }
}
